module.exports = __webpack_public_path__ + "public/images/company_img.445071e541bc5c019893d58358097144.webp";